<template>
  <div>
    <div class="decorative-divider"></div>

    <payment-pricing-table :booking="booking" :payment-amount="paymentAmount"  ></payment-pricing-table>

    <div class="text-center" v-if="paymentMethods.length">
      Select a card:
      <ul class="item-detail item-detail-simple">
        <li :key="paymentMethod.id" v-for="paymentMethod in paymentMethods">
          <div class="ccard-detail flex items-center">
            <div class="ccard-detail__icon">
              <i class="fa fa-credit-card fa-fw"></i>
            </div>
            <div class="ccard-detail__info">
              <div class="ccard-detail__number">
                <span class="ccard-detail__placeholder">XXXX XXXX XXXX</span> {{paymentMethod.last_four?paymentMethod.last_four:'XXXX'}}
              </div>
              <div class="ccard-detail__expiry">
                {{paymentMethod.exp_month}}/{{paymentMethod.exp_year}}
              </div>
              <div class="ccard-detail" v-if="paymentMethod.is_default">Current Default</div>
            </div>
            <ladda-button
              :click="() => { selectPaymentMethod(paymentMethod) }"
              class="btn btn-sm btn-info flex-shrink-0"
              :disabled="submitting">
              Charge Card
            </ladda-button>
          </div>
        </li>
      </ul>
    </div>
    <div v-else-if="loading">
      <pickstar-loading/>
    </div>
    <div class="text-center" v-else>
      No saved cards found.<br />
      <router-link :to="{ name: `profile.show.card-details`, params: { id: this.$user.id } }" active-class="" class="btn btn-sm btn-primary">
        <i class="fa fa-fw fa-plus"></i>
        Add a card
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Selectize from '../ext/codium/CodiumSelectize'
import { loadStripe } from '@stripe/stripe-js'
import { notify } from 'utils'
import LaddaButton from 'codium-ladda-button'
import PaymentPricingTable from './PaymentPricingTable'

export default {
  data () {
    return {
      paymentMethods: [],
      submitting: false,
      loading: false
    }
  },
  props: {
    paymentIds: {
      required: true,
      type: Array
    },
    paymentAmount: {
      required: true,
      type: Number
    },
    cardSurcharge: {
      default: 0,
      required: true,
      type: Number
    }
  },

  components: {
    Selectize,
    LaddaButton,
    PaymentPricingTable
  },

  computed: {
    ...mapState('payment', ['clientToken']),
    ...mapState('booking', ['booking'])
  },
  mounted () {
    this.setupStripe()
    this.loadPaymentMethods()
  },
  methods: {
    async setupStripe () {
      this.stripe = await loadStripe(this.$stripePublicKey(this.booking.region.shortname))
    },
    loadPaymentMethods () {
      this.loading = true
      return this.$http.get('card/payment-methods')
        .then(response => {
          this.paymentMethods = response.data
          this.loading = false
        })
    },
    selectPaymentMethod (paymentMethod) {
      this.submitting = true
      return this.$http.post('/card/charge-selected-payment-method', {
        paymentMethodId: paymentMethod.id,
        paymentIds: this.paymentIds
      }).then(response => {
        this.stripe.confirmCardPayment(response.data.client_secret, {
          payment_method: response.data.payment_method_id
        }).then(response => {
          if (response.paymentIntent.status === 'succeeded') {
            this.submitting = false
            notify.success('Payment Successful')
            this.$router.go()
          } else {
            this.submitting = false
            notify.error('Payment Unsuccessful. Your card has not been charged.')
          }
        })
      })
    }
  }
}
</script>
